import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';

import styles from './styled';
import canUseDOM from '@helpers/canUseDOM';

function VideoOverlay(props) {
  const { onClose, visible, url } = props;
  const youtubeParams =
    '&rel=0&modestbranding=1&enablejsapi=1&origin=https%3A%2F%2Fwww.lucidmotors.com&widgetid=1';

  const videoRef = useRef(null);
  const [videoVisible, setVideoVisible] = useState(false);

  function showVideo() {
    setVideoVisible(true);
    document.body.classList.add('lock');
  }

  function hideVideo() {
    setVideoVisible(false);
    document.body.classList.remove('lock');
  }

  if (!canUseDOM()) return null;

  return ReactDOM.createPortal(
    <CSSTransition
      in={visible}
      timeout={600}
      onEntered={showVideo}
      onExited={hideVideo}
      mountOnEnter
      unmountOnExit
    >
      <styles.Root>
        <styles.IconWrap onClick={onClose} />
        {videoVisible && (
          <styles.Video
            src={
              url.includes('youtube') || url.includes('youtu.be')
                ? url + youtubeParams
                : url
            }
            allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; clipboard-write;"
            frameborder="0"
            ref={videoRef}
            allowfullscreen
          />
        )}
      </styles.Root>
    </CSSTransition>,
    document.body
  );
}

VideoOverlay.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
};

export default VideoOverlay;
